module.exports = __webpack_public_path__ + "static/media/chatbot-response-loader.69d63349.svg";